'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _domUtil = require('../../../../utils/domUtil');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraftLinkAnchor = function DraftLinkAnchor(_ref) {
    var target = _ref.target,
        href = _ref.href,
        className = _ref.className,
        children = _ref.children;
    return _react2.default.createElement(
        'a',
        { className: 'DraftLinkAnchor ' + className, href: href, target: target, onClick: _domUtil.stopPropagationOnly },
        children
    );
};

// Utils
// Lib


DraftLinkAnchor.propTypes = {
    target: _propTypes2.default.string,
    href: _propTypes2.default.string,
    className: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = DraftLinkAnchor;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/linkify/DraftLinkAnchor.js
// module id = 1733
// module chunks = 0